import { IoReturnUpForwardOutline } from "react-icons/io5";
import { AppEnum, AppEnumsRecord } from "../Types";

export class AppEnumHelper {

    constructor(private appEnums?: AppEnumsRecord | null) { }

    get<K extends keyof AppEnumsRecord>(key: K): AppEnum[] {
        return this.appEnums?.[key] ?? [];
    }

    AdSourceCategoryEnum = () => this.get('AdSourceCategoryEnum');

    AdSourceTypeEnum = () => this.get('AdSourceTypeEnum');

    PropertyCategoryEnum = () => this.get('PropertyCategoryEnum');

    PropertyTypeEnum = () => this.get('PropertyTypeEnum');

    PropertyFeatureCategoryEnum = () => this.get('PropertyFeatureCategoryEnum');

    PropertyFeatureTypeEnum = () => this.get('PropertyFeatureTypeEnum');

    accessTypeEnum = () => this.get('AccessTypeEnum');

    publicationCategoryEnum = () => this.get('PublicationCategoryEnum');

    CivilityEnum = () => this.get('CivilityEnum');

    ContactTypeEnum = () => this.get('ContactTypeEnum');

    NeedStatusEnum = () => this.get('NeedStatusEnum');

    OperationTypeEnum = () => this.get('OperationTypeEnum');

    MandateTypeEnum = () => this.get('MandateTypeEnum');

    AvailabilityEnum = () => this.get('PropertyAvailabilityEnum');

    PropertyConditionEnum = () => this.get('PropertyConditionEnum');

    PropertyUsageEnum = () => this.get('PropertyUsageEnum');

    MatchingStatusEnum = () => this.get('MatchingStatusEnum');

    PriceRangeEnum = () => this.get('PriceRangeEnum');

    TaskCategoryEnum = () => this.get('TaskCategoryEnum');

    LeaseTypeEnum = () => this.get('LeaseTypeEnum');

    LeaseOptionEnum = () => this.get('LeaseOptionEnum');

    ActivityStatusEnum = () => this.get('ActivityStatusEnum');

    PlanningTypeEnum = () => this.get('PlanningTypeEnum');

    ActivityPriorityEnum = () => this.get('ActivityPriorityEnum');

    StandingEnum = () => this.get('PropertyStandingEnum');

    ResourceTypeEnum = () => this.get('ResourceTypeEnum');

    UserRoleEnum = () => this.get('UserRoleEnum');

    UserPositionEnum = () => this.get('UserPositionEnum');

    DocumentCategoryEnum = () => this.get('DocumentCategoryEnum');

    DocumentTypeEnum = () => this.get('DocumentTypeEnum');

    AccessTypeEnum = () => this.get('AccessTypeEnum');

    static getByKey = (appEnums: AppEnum[], key: string | number) => appEnums.find(a => a.key === key);

    static getByValue = (appEnums: AppEnum[], value?: string | null) => {
        if (!value) return undefined;
        return appEnums.find(a => a.value === value);
    }

    static isEqualByValue = (appEnums: AppEnum[], value1?: string | null, value2?: string | null) => {
        if(!value1 || !value2) {
            return false;
        }

        const enum1  =  AppEnumHelper.getByValue(appEnums, value1);
        const enum2 = AppEnumHelper.getByValue(appEnums, value2);
        if(!enum1 || !enum2) {
            return false;
        }
        return enum1.value === enum2.value;
    }


    /**
     * Resolves a human-readable label from a list of application enums.
     *
     * This utility is designed for UI usage to avoid displaying raw enum values
     * (technical or backend-oriented) directly to end users.
     *
     * Behavior:
     *  - If the provided value is empty or undefined, the fallback is returned.
     *  - If no fallback is provided, an empty string is returned.
     *  - If a matching enum entry is found, its label is returned.
     *  - If no match is found, the raw value is returned as a safe default.
     *
     * @param appEnums List of application enums containing value/label pairs.
     * @param value Enum value to resolve.
     * @param fallBack Optional fallback label when the value is missing or invalid.
     *
     * @returns A user-friendly label suitable for display in the UI.
     */
    static getLabel = (
        appEnums: AppEnum[],
        value?: string | null,
        fallBack?: string | null) => {
        
        if (!value || !appEnums) {
            return fallBack ?? "";
        }
        
        return appEnums.find(a => a.value === value)?.label
            ?? value
            ?? fallBack
            ?? "";
    }
}